import type {Me} from "@/src/modules/core/types";
import type {Shift} from "@/src/modules/shifts/types";

import type {VehicleCheck} from "../types";

/** Officer / patrol / supervisor tiers — shift rules apply; admin is exempt. */
export function vehicleCheckCreateRequiresActiveShift(me: Me | null | undefined) {
  if (!me || me.isAdmin) return false;
  return (
    me.isOfficer ||
    me.isPatrolOfficer ||
    me.isSupervisor ||
    me.isSeniorSupervisor
  );
}

/** Officer and patrol officer shifts must include the checked property. */
export function vehicleCheckCreateRequiresPropertyOnShift(me: Me | null | undefined) {
  if (!me) return false;
  return me.isOfficer || me.isPatrolOfficer;
}

export function shiftIncludesProperty(
  shift: Shift | null | undefined,
  propertyId: number,
) {
  if (!shift?.properties?.length) return false;
  return shift.properties.some((entry) => entry.property.id === propertyId);
}

/** Admins must not send `shift_id` on create — server stores null shift. */
export function shouldSendShiftIdOnVehicleCheckCreate(me: Me | null | undefined) {
  return Boolean(me && !me.isAdmin);
}

export function getVehicleCheckCreateShiftBlockMessage(
  me: Me | null | undefined,
  shift: Shift | null | undefined,
  propertyId: number,
): string | null {
  if (!vehicleCheckCreateRequiresActiveShift(me)) return null;
  if (!shift) return "An active shift is required to create a vehicle check.";
  if (
    vehicleCheckCreateRequiresPropertyOnShift(me) &&
    !shiftIncludesProperty(shift, propertyId)
  ) {
    return "The active shift does not include this property.";
  }
  return null;
}

/** Citations / stored vehicles must not link when the check is off-site. */
export function canLinkVehicleCheckToEnforcement(check: VehicleCheck | null | undefined) {
  return Boolean(check && check.outside_perimeter !== true);
}
